import React, { useRef, useEffect, useMemo } from 'react';
import c from 'classnames';

import { Node } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import Pager from '../../../components/Pager';

import './style.scss';

const LatestLocationContent = (props) => {
  const ref = useRef(null);
  const viewIsLoaded = useRef(null);
  const { blockTitle, entities, pager, page, setCurrentPage } = props;
  const totalPages = pager.get('total_pages');

  useEffect(() => {
    if (ref.current) {
      if (viewIsLoaded.current) {
        ref.current.scrollIntoView();
      } else {
        viewIsLoaded.current = true;
      }
    }
  }, [ref, page]);

  const isLoading = useMemo(() => {
    return page !== pager.get('current_page');
  }, [page, pager]);

  const ViewClasses = c('LatestLocationContent', {
    'LatestLocationContent--no-pager': totalPages <= 1,
    'LatestLocationContent--loading': isLoading,
  });

  return (
    entities.size > 0 && (
      <div className={ViewClasses} ref={ref}>
        <div className="row">
          <div className="col-12 heading-holder">
            <h2>{blockTitle}</h2>
          </div>
        </div>
        <div className="row">
          {entities.map((entity, index) => {
            const id = entity.getIn(['nid', 0, 'value']);
            const uuid = entity.getIn(['uuid', 0, 'value']);
            const type = entity.getIn(['type', 0, 'target_id']);
            const className = c('col-sm-12', {
              'col-md-6 col-lg-4': type === "article" || type === "project",
            })
            return (
              <div key={uuid} className={className}>
                <Node
                  id={id}
                  entity={entity}
                  viewMode="teaser"
                  labeled={false}
                />
              </div>
            );
          })}
          <div className="LatestLocationContent__pager">
            <Pager currentPage={page} totalPages={totalPages} setCurrentPage={setCurrentPage} />
          </div>
        </div>
      </div>
    ));
};

export default LatestLocationContent;
